// import "moment/locale/ar";
import moment from 'moment/moment';
import { ISingleOrderComment } from '../types/interfaces';
import { useState } from 'react';
import { deleteIcon, editCommentIcon, sendIcon } from '../../../config/variables';
import { useTranslation } from 'react-i18next';
import { Form, Formik, FormikHelpers } from 'formik';
import FieldWrapper from '../../../components/formInputs/FieldWrapper';
import Button from '../../../components/buttons/Button';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { axiosInstance } from '../../../config/axiosConfig';
import * as Yup from 'yup';
import { toast } from 'react-toastify';

export default function StepCommentsItem({ comment }: { comment: ISingleOrderComment }) {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const [updateField, setUpdateField] = useState(false);

  const updateCommentMutation = useMutation({
    mutationFn: async (values: FormValues) =>
      await axiosInstance(`comments/${comment?.id}`, {
        data: { ...values },
        method: 'PUT'
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['comments'] });
      toast.success(`${t('updateComment')} ${t('successfully')}`);
      setUpdateField(false);
    }
  });

  interface FormValues {
    body: string;
    is_resolved?: boolean;
  }
  const initialValues: FormValues = { body: comment?.body || '' };
  const validationSchema = Yup.object({
    body: Yup.string().min(3).max(150).required(t('required'))
  });
  const onSubmit = (values: FormValues, { resetForm }: FormikHelpers<FormValues>) => {
    updateField && updateCommentMutation.mutate(values);
  };

  function getTime(date: string) {
    const today = moment().format('YYYY-MM-DD');
    const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');
    const currDate = moment(date).format('YYYY-MM-DD');

    if (currDate === today) {
      return `Today, ${moment(date).format('hh:mm A')}`;
    } else if (currDate === yesterday) {
      return `Yesterday, ${moment(date).format('hh:mm A')}`;
    } else {
      return moment(date).format('DD MMM YYYY, hh:mm A');
    }
  }
  return (
    <div className="comments-item step" key={`comment-${comment.id}`}>
      <div className="comments-text">
        <div className="comments-text-top">
          <h4 className="comment-author">{comment?.user?.name}</h4>
          <div className="comments-replies-date">{getTime(comment.created_at)}</div>
        </div>
        <p className="comment-body">{comment.body}</p>
      </div>
    </div>
  );
}
